import { useCallback, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { getFlightDetailsFetchStatus } from "../../store/flightDetails/selectors.js";
function createAbortController() {
    if (typeof AbortController === "undefined")
        return undefined;
    return new AbortController();
}
export default function useFlightDetailsAbortApiCallWeb(key) {
    const fetchStatus = useSelector(getFlightDetailsFetchStatus);
    const controllerRef = useRef({
        requestKey: key,
        controller: createAbortController()
    });
    if (controllerRef.current.requestKey !== key) {
        controllerRef.current = { requestKey: key, controller: createAbortController() };
    }
    const controller = controllerRef.current.controller;
    const fetchStatusRef = useRef(fetchStatus);
    fetchStatusRef.current = fetchStatus;
    useEffect(() => {
        return () => {
            const ctrl = controllerRef.current?.controller;
            if (!ctrl)
                return;
            if (ctrl.signal?.aborted)
                return;
            if (fetchStatusRef.current === "success" || fetchStatusRef.current === "failed")
                return;
            ctrl.abort("CANCELLED_DUE_TO_UNMOUNTING");
        };
    }, []);
    const isAbortError = useCallback((err) => {
        return !!controller?.signal?.aborted || ("message" in err && err.message === "CANCELLED_DUE_TO_UNMOUNTING");
    }, [controller?.signal]);
    return { signal: controller?.signal, isAbortError };
}
